export default "__VITE_ASSET__ScYPf6SZ__"